// @ts-nocheck
import {moduleInstanceKey, onLoadKey} from "./defineDynamicImport";

if (!window['__federation__']) {

    // @ts-ignore
    const scriptSrc = document.currentScript?.src;
    const __public_auto_path__ = scriptSrc ? scriptSrc.split('/').slice(0, -1).join('/') : '';

    window['__federation__'] = {
        __public_auto_path__,
        __use_public_auto_path__: true,
        __public_path__: undefined,
        __loading_timeout__ : 5 * 1000
    };
} else {
    console.log('__federation__ loaded more than once.');
}

window['__federation__']['load__federation__'] = (scriptFilePath, moduleName, onLoad) => {

    if (!window['__federation__'][moduleName]) {
        let scriptTag;

        window['__federation__'][moduleName] = {};
        window['__federation__'][moduleName][onLoadKey] = (module) => {
            if (scriptTag) {
                document.head.removeChild(scriptTag);
                //TODO : check that:
                scriptTag = null;
                // console.log('script removed... ')
            }
            //console.log(module);

            window['__federation__'][moduleName][moduleInstanceKey] = module;
            onLoad(module);
        }

        const loadScript = (src) => {
            scriptTag = document.createElement('script');
            scriptTag.type = 'module';
            scriptTag.src = src;
            scriptTag.async = true;

            // Fallback to CDN if the script fails to load (e.g. caching proxies like LiteSpeed
            // relocate the root SDK but don't have the chunk files)
            scriptTag.onerror = () => {
                const cdnBase = window.myop?.__ROOT_SDK_PUBLIC_URL__?.split('/').slice(0, -1).join('/');
                const chunkFileName = src.split('/').pop();
                if (cdnBase && !src.startsWith(cdnBase)) {
                    console.warn(`[myop] chunk load failed from ${src}, retrying from CDN`);
                    document.head.removeChild(scriptTag);
                    loadScript(`${cdnBase}/${chunkFileName}`);
                }
            };

            document.head.appendChild(scriptTag);
        };

        loadScript(scriptFilePath);

        // const link = document.createElement("link");
        // link.type = "text/css";
        // link.rel = "stylesheet";
        // link.href = fileName.replace('.js', '.css');
        // document.body.appendChild(link);

    } else {
        console.log(`__federation__ module ${moduleName} already loaded.`)
        onLoad(window['__federation__'][moduleName][moduleInstanceKey]);
    }
}
